import Spinner from '../Spinner'
import React, { ButtonHTMLAttributes, useContext } from 'react'
import { ContextApp } from '@monorepo/service'
import { classNames } from '@monorepo/utils'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isloading?: boolean;
}

const ButtonLoader: React.FC<React.PropsWithChildren<ButtonProps>> = ({ children, ...rest }) => {
  const {isCdaPending} = useContext(ContextApp)

  const isLoading = isCdaPending || rest.isloading;
  const disabled = rest.disabled;

  return <button {...rest} about={isLoading ? 'isLoading' : ''} className={classNames(rest.className, isLoading && 'isLoading')} disabled={disabled}>
    {children} {isLoading && <Spinner />}
  </button>
}

export default ButtonLoader
